/**
 *授权用户管理接口实现
 *@author xujinjiang
 *@date 2022/3/3 17:25
 */
import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import { AuthorizationUserUrlConfig } from '@/config/AuthorizationUserUrlConfig';
import { LocalStorageManager } from '@/db/LocalStorageManager';

export class AuthorizationUserServiceImpl extends BaseServiceImpl {
  private static service: AuthorizationUserServiceImpl;

  public static getInstance(): AuthorizationUserServiceImpl {
    if (AuthorizationUserServiceImpl.service == null) {
      AuthorizationUserServiceImpl.service = new AuthorizationUserServiceImpl();
    }

    return AuthorizationUserServiceImpl.service;
  }

  /**
   * 获取机构授权列表
   * @param orgId
   * @param orgName
   * @param pageNo
   * @param pageSize
   */
  getAuthorizationUserList(
    developerId: string,
    orgId: string,
    orgName: string,
    openId: string,
    pageNo: any,
    pageSize: any
  ): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = AuthorizationUserUrlConfig.getAuthorizationUserList;
    option.params = {
      developerId: developerId,
      orgId: orgId,
      orgName: orgName,
      pageNo: pageNo,
      pageSize: pageSize,
      openId: openId
    };
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  getUserLogList(userId: string, startDate: string, endDate: string, pageNo: any, pageSize: any) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = AuthorizationUserUrlConfig.getUserLogList;
    const developerId = LocalStorageManager.getUser().id;
    option.params = {
      developerId: developerId,
      openId: userId,
      startDate: startDate,
      endDate: endDate,
      pageNo: pageNo,
      pageSize: pageSize
    };
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
